import { functions } from './firebase';

export const exportTransactions = (organizationId, searchConditions) =>
  functions().httpsCallable('callables-transactions-exportTransactions')({ organizationId, searchConditions });
